import React from 'react';
import { handleDummyAction } from '../../utils/Dummy';
const defaultValue = {
    breadcrumbs: [],
    addAnchor: handleDummyAction,
    updateAnchor: handleDummyAction,
    removeAnchor: handleDummyAction,
    addAnchors: handleDummyAction,
    removeAnchors: handleDummyAction,
};
const BreadcrumbsContext = React.createContext(defaultValue);
export default BreadcrumbsContext;
